import React from 'react';
import JavascriptGraphics from './JavascriptGraphics.jsx';
import JavascriptGraphicsCanvas from './JavascriptGraphicsCanvas.jsx';
import JavascriptGraphicsPlotly from './JavascriptGraphicsPlotly.jsx';
import JavascriptGraphicsChartjs from './JavascriptGraphicsChartjs.jsx';
import JavascriptGraphicsGoogleChart from './JavascriptGraphicsGoogleChart.jsx';
import JavascriptGraphicsD3 from './JavascriptGraphicsD3.jsx';

export default function JsGraphics() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Graphics</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/graphics' className='underline'>JS Graphics</a></li>
<li><a href='/javascript/graphics/canvas' className='underline'>JS Canvas</a></li>
<li><a href='/javascript/graphics/plotly' className='underline'>JS Plotly</a></li>
<li><a href='/javascript/graphics/chartjs' className='underline'>JS Chart.js</a></li>
<li><a href='/javascript/graphics/google-chart' className='underline'>JS Google Chart</a></li>
<li><a href='/javascript/graphics/d3' className='underline'>JS D3.js</a></li>
      </ul>
    </div>
  );
}
